export interface Bridge {
  name: string
  url: string
}

export const mainnetBridges: Bridge[] = [
  {
    name: 'Polygon Bridge',
    url: 'https://wallet.polygon.technology/polygon/bridge',
  },
  {
    name: 'Base Bridge',
    url: 'https://bridge.base.org',
  },
]

export const testnetBridges: Bridge[] = []
